import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-country-dialog-box',
  templateUrl: './country-dialog-box.component.html',
  styleUrls: ['./country-dialog-box.component.scss']
})
export class CountryDialogBoxComponent implements OnInit {

  displayColumns = ['CountryCode', 'CountryName'];
  CountryForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  countryList: any;
  isreadonlydel = false;
  country: string;
  list;
  countryform: any;;
  APIService: any;
  deleteButton: boolean;
  CountryCodefordelete;
  isreadonly = false;
  userPermission: any;
  utp: string;
  dialogRef: MatDialogRef<any>;
  CountryCreate = true;
  CountryUpdate = true;
  CountryDelete = true;
  constructor(public umsService: UmsService,
    private dialogRef2: MatDialogRef<CountryDialogBoxComponent>,
    private modalPopupService: ModalpopService,

    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee'); 
    if (this.utp !== 'Super Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Country' && element.PCreate == false) {
          this.CountryCreate = false;
        }
        if (element.PageName == 'Country' && element.PUpdate == false) {
          this.CountryUpdate = false;
        }
        if (element.PageName == 'Country' && element.PDelete == false) {
          this.CountryDelete = false;
        }
      });
    }
    window.scroll(0, 0);
    this.CountryCodefordelete = 0;
    this.submitButton = true;
    this.editButton = false;
    this.getCountryData();
    this.list = true;
    this.CountryForm = this.fb.group({

      CountryCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-&]*$')]),
      CountryName: new FormControl('', [Validators.required, Validators.pattern('^[\\S]{1,}[\\S\\s]*|[\\s]*[\\S]{1,}[\\S\\s]*')]),

    });
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.deletee(this.data.selected);
    } else {
      // alert(this.data.key)
    }
  }

  getCountryData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCountry(payload).subscribe(res => {
      this.countryList = res.data;
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.countryList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  prepopulation(id) {
    const payload = {};
    payload['CountryCode'] = id;
    this.umsService.getCountry(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.editButton = true;
        this.isreadonly = true;
        this.submitButton = false;
        this.deleteButton = false;
        this.CountryForm = this.fb.group({
          CountryCode: new FormControl(data.CountryCode, [Validators.required, Validators.pattern('^[a-zA-Z - &\\s]*$')]),
          CountryName: new FormControl(data.CountryName, [Validators.required]),
        });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  deletedata(id) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        CountryName: id.CountryName,
        CountryCode: id.CountryCode,
      },
    };
    this.httpClient.delete(this.APIService + '/masters/country', options)
      .subscribe((s) => {
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ngOnInit();
          this.dialogRef2.close()
        });
      }, (ERROR: HttpErrorResponse) => {

        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      });

  }


  deletee(k) {
    this.list = false;
    this.getCountryData();
    const payload = {};

    payload['CountryCode'] = k;
    this.umsService.getCountry(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        this.isreadonlydel = true;
        this.deleteButton = true;
        this.CountryForm = this.fb.group({
          CountryCode: new FormControl(data.CountryCode, [Validators.required, Validators.pattern('^[a-zA-Z - &\\s]*$')]),
          CountryName: new FormControl(data.CountryName, [Validators.required]),
        });
        this.CountryCodefordelete = this.CountryForm.value;
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
    // } else {
    //   this.list = true;
    // }
  }
  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.CountryCodefordelete);
      } else {
        // this.ngOnInit();
      }
    });
  }

  submit() {
    if (this.CountryForm.invalid) {
      this.CountryForm.get('CountryCode').markAsTouched();
      this.CountryForm.get('CountryName').markAsTouched();
      return;
    } else {
      this.createCountry();
    }

  }



  createCountry() {
    this.spinner.show();
    this.submitpayload = this.CountryForm.value;
    this.submitpayload['CountryName'] = this.submitpayload['CountryName'].replace(/\s+/g, ' ').trim();
    this.submitpayload['CountryCode'] = this.CountryForm.value.CountryCode;
    this.umsService.addCountry(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.countryList = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.spinner.hide();

    });
  }

  update() {
    if (this.CountryForm.invalid) {
      this.CountryForm.get('CountryCode').markAsTouched();
      this.CountryForm.get('CountryName').markAsTouched();
      return;
    } else {
      this.updateCountry();
    }
  }

  updateCountry() {
    this.spinner.show();
    let submitpayload = this.CountryForm.value;
    this.umsService.updateCountry(submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    }, (ERROR: HttpErrorResponse) => {
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.spinner.hide();
    });
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.isreadonly = false;
      this.getCountryData();
      // this.CountryForm = k;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }


  
}



